var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section text-left" }, [
    _c("h3", { staticClass: "sr-only" }, [_vm._v("Services")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "fa-ul", staticStyle: { "--list-margin-top": "0" } },
      [
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.download.iconColor}`,
                attrs: { icon: _vm.context.download.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.context.download.hasAccessToProDownloads
            ? _c(
                "span",
                {
                  class: _vm.serviceStylingUnavailable,
                  attrs: {
                    "aria-label":
                      "Gives you permission to download Font Awesome Pro icons.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Icon Downloads\n      ")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Gives you permission to download Font Awesome Pro icons.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Icon Downloads\n      ")]
              ),
        ]),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "margin-bottom-sm padding-left-sm" },
          [
            _c(
              "span",
              { staticClass: "fa-li" },
              [
                _c("font-awesome-icon", {
                  class: `${_vm.context.license.iconColor}`,
                  attrs: { icon: _vm.context.license.icon, size: "lg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.context.license.hasPerpetualLicense && !_vm.$dt.isBacker
              ? _c(
                  "site-link",
                  {
                    class: _vm.serviceStylingUnavailable,
                    attrs: {
                      to: { name: "license.pro" },
                      "aria-label":
                        "Allows you to use Pro Icons with more than just hosted kits on your website. Additionally embed Pro Icons in your own native apps, install and use them on the desktop, and download and serve Pro Icons yourself. View more details.",
                      "data-balloon-pos": "up",
                      "data-balloon-length": "large",
                    },
                  },
                  [_vm._v("\n        Perpetual License\n      ")]
                )
              : _vm.context.license.hasProBackerLicenseOnly
              ? _c(
                  "site-link",
                  {
                    attrs: {
                      to: {
                        name: "support",
                        hash: "#font-awesome-5-kickstarter-pre-order-licenses",
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("support_link_click", {
                          context: "plan_card",
                          location: "backer_license",
                        })
                      },
                    },
                  },
                  [_vm._v("\n        Backer Pro License\n      ")]
                )
              : _c(
                  "site-link",
                  {
                    attrs: {
                      to: { name: "license.pro" },
                      "aria-label":
                        "Allows you to use Pro Icons with more than just hosted kits on your website. Additionally embed Pro Icons in your own native apps, install and use them on the desktop, and download and serve Pro Icons yourself. View more details.",
                      "data-balloon-pos": "up",
                      "data-balloon-length": "large",
                    },
                  },
                  [_vm._v("\n        Perpetual License\n      ")]
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.packages.iconColor}`,
                attrs: { icon: _vm.context.packages.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.context.packages.hasAccessToPrivateNpm
            ? _c(
                "span",
                {
                  class: _vm.serviceStylingUnavailable,
                  attrs: {
                    "aria-label":
                      "Access Font Awesome Pro private packages for building complex web apps.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Pro Packages + Plugins\n      ")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Access Font Awesome Pro private packages for building complex web apps.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Pro Packages + Plugins\n      ")]
              ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.support.iconColor}`,
                attrs: { icon: _vm.context.support.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.context.support.hasAccessToHumanSupport
            ? _c(
                "span",
                {
                  class: _vm.serviceStylingUnavailable,
                  attrs: {
                    "aria-label":
                      "Get help from a real human when you need it. Seriously.",
                    "data-balloon-pos": "up",
                  },
                },
                [_vm._v("\n        Actual Human™ Support\n      ")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Get help from a real human when you need it. Seriously.",
                    "data-balloon-pos": "up",
                  },
                },
                [_vm._v("\n        Actual Human™ Support\n      ")]
              ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }